<template lang="pug">
modal.checkbox-settings-modal(
  :process-button-label='$t("button.ok")'
  :show-cancel-button='false'
  :title='$t("modal.qrcode_settings.title")'
  @process='process'
  ref='modal'
  size='sm'
)
  .col-12(v-if='element')
    p {{ $t('modal.qrcode_settings.description') }}
    .text-center
      img(src='/images/qrcode-solid.svg' style='width: 70px')
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      element: {},
    };
  },
  methods: {
    process() {
      this.$emit('settings', this.element);
      this.$refs.modal.close();
    },
  },
};
</script>
<style lang="stylus"></style>
